import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Http_Header_Request_Options } from '../core/httpheader';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import * as ApiConfig from './apiconfig';
import { ParamInfo } from './index.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ParamService {
    private apiUrl: string;

    constructor(private http: Http, private httpclient: HttpClient) {
        this.apiUrl = ApiConfig.API_URL + ApiConfig.API_Param;
    }

    getParam(JurisNo: number, paramID): Promise<ParamInfo> {
        return this.http.get(this.apiUrl + "/" + JurisNo + "/" + paramID, Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as ParamInfo)
            .catch(this.handleError);
    }


    getParamInfo(JurisNo: number): Promise<ParamInfo[]> {
        return this.http.get(this.apiUrl + "/" + JurisNo, Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as ParamInfo[])
            .catch(this.handleError);
    }

    ParamInsert(model: ParamInfo[]) {
        let body = model;

        return this.http.post(this.apiUrl, body, Http_Header_Request_Options)
            .toPromise()
            .then(res =>
            {
                return res.json() as ParamInfo[];
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/param.service.ts